
define('text!common/views/commercial/tracking-pixel.html',[],function () { return '<img src="<%=url%>" class="creative__tracking-pixel">\n';});

